export default "__VITE_ASSET__d7e807dd__"